import { COMPLAINT_CASE_FORM_PATH, COMPLAINT_CASE_FORM_BY_HASH_PATH } from '../../constants/paths';
import { complaintCaseFormAction } from './actions';
import { complaintCaseFormLoader, ComplaintCaseForm } from './complaint_case_form';


// Router by hash
const complaintCaseFormHashRoutes = [
  {
      path: `${COMPLAINT_CASE_FORM_BY_HASH_PATH}:authHash`,
      element: <ComplaintCaseForm key="complaint_case_form_by_hash" accessByHash={true}/>,
      loader: complaintCaseFormLoader,
      shouldRevalidate: () => false,
      action: complaintCaseFormAction
  }
];

export { complaintCaseFormHashRoutes };

// Route when authenticated
const complaintCaseFormRoutes = [
  {
      path: COMPLAINT_CASE_FORM_PATH.replace('{id}', ':complaint_case_id').slice(1),
      element: <ComplaintCaseForm key="complaint_case_form" accessByHash={false}/>,
      loader: complaintCaseFormLoader,
      shouldRevalidate: () => false,
      action: complaintCaseFormAction
  }
];

export { complaintCaseFormRoutes };